<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <span style="margin-top: 5px">{{ title }}</span>
        <v-fade-transition>
           <span style="display: inline-flex" v-if="open">
              <v-divider class="mx-2" vertical/>
              <v-menu
                :absolute="false"
                :close-on-click="true"
                :close-on-content-click="true"
                :offset-y="true"
              >
                  <template v-slot:activator="{ on }">
                      <v-btn v-on="on" small color="primary">
                        Add <v-icon class="ml-2" x-small>mdi-text-box</v-icon>
                      </v-btn>
                  </template>
                  <v-list v-for="(kind,i) in values" :key="i" dense class="pa-0">
                      <v-list-item @click="row_create(kind)" dense>
                          <v-list-item-title v-text="kind.name"/>
                      </v-list-item>
                  </v-list>
              </v-menu>
           </span>
        </v-fade-transition>
        <v-spacer/>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-divider class="mb-2"/>
      <v-chip
        v-for="(trigger,i) in items"
        :key="i"
        class="ma-1"
        :color="trigger.visible ? 'green':'blue darken-1'"
        :outlined="!trigger.visible"
        :text-color="trigger.visible ? 'white':'blue'"
        close
        @click="row_update(trigger)"
        @click:close="row_remove(trigger)"
      >
        {{ trigger.kind.name }}
      </v-chip>
    </v-expansion-panel-content>

    <r-trigger-generic ref="trigger_1"/>
    <r-trigger-item ref="trigger_2"/>
    <r-trigger-quest ref="trigger_3"/>
    <r-trigger-talk ref="trigger_4"/>
    <r-trigger-item-group ref="trigger_5"/>
    <r-trigger-order ref="trigger_6"/>
    <r-trigger-tutorial ref="trigger_7"/>
    <r-trigger-product ref="trigger_8"/>
    <r-trigger-currency ref="trigger_9"/>
    <r-trigger-group ref="trigger_10"/>
    <r-trigger-trader ref="trigger_11"/>
    <r-trigger-ship ref="trigger_12"/>
    <r-trigger-johan ref="trigger_13"/>
    <r-trigger-smart-offer ref="trigger_14"/>
  </v-expansion-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {TriggerBase} from "@/modules/redactor/models/trigger/core/TriggerBase";
import {TriggerKind} from "@/modules/redactor/models/trigger/core/TriggerKind";

import RTriggerOrder from "@/modules/redactor/views/trigger/r-trigger-order";
import RTriggerProduct from "@/modules/redactor/views/trigger/r-trigger-product";
import RTriggerCurrency from "@/modules/redactor/views/trigger/r-trigger-currency";
import RTriggerQuest from "@/modules/redactor/views/trigger/r-trigger-quest";
import RTriggerTalk from "@/modules/redactor/views/trigger/r-trigger-talk";
import RTriggerTutorial from "@/modules/redactor/views/trigger/r-trigger-tutorial";
import RTriggerGeneric from "@/modules/redactor/views/trigger/r-trigger-generic";
import RTriggerItem from "@/modules/redactor/views/trigger/r-trigger-item";
import RTriggerItemGroup from "@/modules/redactor/views/trigger/r-trigger-item-group";
import RTriggerGroup from "@/modules/redactor/views/trigger/r-trigger-group";
import RTriggerTrader from "@/modules/redactor/views/trigger/r-trigger-trader";
import RTriggerShip from "@/modules/redactor/views/trigger/r-trigger-ship";
import RTriggerJohan from "@/modules/redactor/views/trigger/r-trigger-johan";
import RTriggerSmartOffer from "@/modules/redactor/views/trigger/r-trigger-smart-offer.vue";


export default {
  name: "r-trigger-panel",
  components: {
    RTriggerSmartOffer,
    RTriggerJohan,
    RTriggerShip,
    RTriggerTrader,
    RTriggerGroup,
    RTriggerItemGroup,
    RTriggerItem,
    RTriggerGeneric,
    RTriggerTutorial,
    RTriggerTalk,
    RTriggerQuest,
    RTriggerProduct,
    RTriggerOrder,
    RTriggerCurrency
  },
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(TriggerBase),
  },
  computed: {
    values() {
      return TriggerKind.getValues();
    }
  },
  methods: {
    row_create(kind) {
      this.$refs['trigger_' + kind.id].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(trigger) {
      this.$refs['trigger_' + trigger.kind.id].show(ViewRules.UPDATE, trigger.clone())
          .then((data) => {
            const index = this.items.indexOf(trigger);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(trigger) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(trigger);
        this.items.splice(index, 1);
      });
    }
  }
}

</script>
